<template>
  <div class="seller-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>

        <FormItem>
          <Button @click="addGoodCate"
                  type="success"
                  class="f-r">创建</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1000"
            :mask-closable="false"
            :styles="styles">
      <Form :model="seller"
            :label-width="80"
            ref="goodsValidate"
            :rules="goodsValidate">
        <FormItem label="标签名称"
                  prop="title">
          <Input v-model="seller.title"></Input>
        </FormItem>

        <FormItem label="缩略图"
                  prop="thumb">
          <upload-thumb v-model="seller.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="120" :autoCropHeight="120"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:120*120,大小不超过2M'"></upload-thumb>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="editgoods('goodsValidate')">提交</Button>
      </div>
    </Drawer>
    <!-- 图片查看 start -->
    <viewer :options="viewerOptions"
            :images="viewerImages"
            @inited="inited"
            class="viewerImageWraper"
            ref="viewerImageWraper">
      <template slot-scope="scope">
        <figure class="images">
          <div class="image-wrapper"
               v-for="img in viewerImages"
               :key="img">
            <img class="image"
                 :src="img"
                 :data-source="img"
                 :alt="img"
                 style="display: none;" />
          </div>
        </figure>
      </template>
    </viewer>
    <!-- 图片查看 end -->
  </div>
</template>

<script>
import UploadThumb from "../../common/thumb";
export default {
  name: "seller-list",
  data () {
    const validateTitle = (rule, value, callback) => {
      if (this.seller.title == "") {
        callback(new Error("标题必须填写"));
      } else {
        callback();
      }
    };
    const validateThumb = (rule, value, callback) => {
      if (this.$refs["uploadthumb"].uploadList.length == 0) {
        callback(new Error("请上传缩略图"));
      } else {
        callback();
      }
    };
    return {
      viewerOptions: {
        toolbar: true,
        url: "data-source"
      },
      viewerImages: [],
      pooltablelist: [],
      exportLoading: false,
      //抽屉参数
      value3: false,
      isable: false,
      thumbRefList: [
        "zero",
      ],
      thumblist: [],
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },

      seller: {},
      isClear: false,
      loading: true,
      dataloading: true,
      currentId: 0,
      title: "编辑",
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "ID",
          key: "id",
          width: 100
        },
        {
          title: "名称",
          key: "title",
          minWidth: 100
        },
        {
          title: "标签图",
          key: "thumb",
          width: 300,
          render: (h, params) => {
            return h("div", [
              h(
                "Avatar",
                {
                  props: {
                    src: this.$publicData.ossUrl + params.row.thumb,
                    shape: "square",
                    size: "large",
                    click: ""
                  },
                  nativeOn: {
                    click: () => {
                      this.showBigImage(params.row.thumb);
                    }
                  }
                },
                ""
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 500,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      status: 1,
      goodsValidate: {
        title: [{ required: true, validator: validateTitle, trigger: "blur" }],
        thumb: [
          { required: true, validator: validateThumb, trigger: "change" }
        ],

      },
    };
  },
  created: function () {
    this.getTableList();
  },
  components: {
    UploadThumb,
  },
  watch: {},
  methods: {
    inited (viewer) {
      this.$viewer = viewer;
    },
    getTableList: function () {
      this.$api.goodattrtag
        .list({
          page: this.pages.page,
          size: this.pages.size
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    addGoodCate: function () {
      this.thumblist = [];
      this.showModalStatus = !this.showModalStatus;
      this.currentId = 0;
      // this.seller = [];
      this.seller.title = "";
    },
    // 详情
    detail (index) {
      this.thumblist = [];
      this.showModalStatus = !this.showModalStatus;
      this.currentId = index;
      this.$api.goodattrtag.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.seller = res.result;
          if (this.seller.thumb != null && this.seller.thumb != "") {
            this.thumblist.push({
              name: this.seller.thumb,
              url: this.seller.thumb,
              status: "finished"
            });
          }
          this.$Message.success(res.msg);
        } else {
          this.$Message.success(res.msg);
        }
      });
    },
    // 修改
    editgoods (name) {
      this.$refs[name].validate(valid => {
        // console.log(valid);
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.seller.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          } else {
            this.seller.thumb = null;
          }
          if (
            this.currentId == null ||
            this.currentId == 0 ||
            this.currentId == ""
          ) {
            this.$api.goodattrtag.create(this.seller).then(res => {
              if (res.code == 200) {
                this.showModalStatus = false;
                this.getTableList();
              }
            });
          } else {
            this.$api.goodattrtag.edit(this.seller).then(res => {
              if (res.code == 200) {
                this.showModalStatus = false;
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });

    },
    // 删除
    remove: function (id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.goodattrtag.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    change () { },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.goodattrtag.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
